export default {"src":"/_next/static/media/gold-rate.1695c0d2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};